import React, { useState } from 'react'
import { useQuery } from 'react-query'

import { UserMissionEnum } from '@interfaces/UserMissionEnum'
import { useUserMissionAction } from '@hooks/userMission/useUserMissionAction'
import { RewardTabAcceptProps, RewardProps } from './interface'

export function withRewardTab(Component: React.FC<RewardProps>) {
  function WithRewardTab({ userId }: RewardTabAcceptProps) {
    const userMissionClient = useUserMissionAction()

    const [userMissionType, setUserMissionType] = useState<UserMissionEnum>(
      UserMissionEnum.READER
    )

    const { data = [], isLoading } = useQuery(
      ['user-mission', userMissionType],
      () => userMissionClient.getUserMissionById(userId, userMissionType)
    )

    function handleUserMissionTypeChange(value: UserMissionEnum) {
      setUserMissionType(value)
    }

    const componentProps = {
      data,
      isLoading,
      userMissionType,
      handleUserMissionTypeChange,
    }

    return <Component {...componentProps} />
  }

  return WithRewardTab
}
